// extracted by mini-css-extract-plugin
export default {"card":"Card_card__2L9zF","BackTitle":"Card_BackTitle__l7Hch","iconHolder":"Card_iconHolder__rovSP","sepLine":"Card_sepLine__2uv0q","fontSize":"Card_fontSize__UsJHq"};